/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clear_Formatting_Selected_EventsInputs */



/**
* | output |
* | --- |
* | "Clear formatting of selected events" |
*
* @param {Clear_Formatting_Selected_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const clear_formatting_selected_events = /** @type {((inputs?: Clear_Formatting_Selected_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clear_Formatting_Selected_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Effacer la mise en forme des événements sélectionnés")
	if (locale === "de") return /** @type {LocalizedString} */ ("Übersichtliche Formatierung ausgewählter Ereignisse")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cancella la formattazione degli eventi selezionati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Четкое форматирование выбранных событий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formato claro de eventos seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("所选事件的清晰格式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントの書式をクリアする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित घटनाओं का स्पष्ट स्वरूपण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Formatação clara dos eventos selecionados")
	return /** @type {LocalizedString} */ ("Clear formatting of selected events")
});